module.exports = __webpack_public_path__ + "officialStatic/img/productAp.5f414d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productAp.png
// module id = 0emJ
// module chunks = 0